module.exports = __webpack_public_path__ + "8bb5f48ebd9f59265d47dd17f8e84fc9.MP3";